import api from "./api";

/**
 * GET /business/google-place/candidates — places on Google matching `q`,
 * nearest first when a position is known. Without `q` it only answers whether
 * search is available on this server. A Google outage is an empty list.
 */
export const fetchGoogleCandidates = async ({ q = "", lat, lng } = {}) => {
  const params = {};
  if (q) params.q = q;
  if (lat !== "" && lat != null && lng !== "" && lng != null) {
    params.lat = lat;
    params.lng = lng;
  }

  const { data } = await api.get("/business/google-place/candidates", { params });
  return data.data;
};

/** PUT /business/branches/{id}/google-place — links the place; returns the branch. */
export const linkGooglePlace = async (branchId, placeId) => {
  const { data } = await api.put(`/business/branches/${branchId}/google-place`, { place_id: placeId });
  return data.data.branch;
};

/** DELETE /business/branches/{id}/google-place — returns the branch. */
export const unlinkGooglePlace = async (branchId) => {
  const { data } = await api.delete(`/business/branches/${branchId}/google-place`);
  return data.data.branch;
};

/** Google's "Place ID Finder", for owners entering an id by hand. */
export const PLACE_ID_HELP_URL =
  "https://developers.google.com/maps/documentation/places/web-service/place-id";
